module.exports = __webpack_public_path__ + "img/dummy14.b80ead8.jpg";